<template>
  <div ref="loadingContainer">
    <div style="width: 100%">
      <Datatable v-bind="$data" :HeaderSettings="false">
        <div slot="table" v-if="pending"></div>
      </Datatable>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Datatable from 'vue2-datatable-component-mhascak'
// import DatatableLocale from './lib/datatable-local-cs'
import GridComponents from '@components/dataGrid'
import { Promise } from 'bluebird'
import CMSGalleryApi from '@api/cms/gallery'

Vue.use(Datatable)

export default {
  name: 'GalleryTable',
  components: { ...GridComponents },
  props: ['row'],
  methods: {
    loadData() {
      CMSGalleryApi.getGalleryGridResult({
        params: {
          pq_filter: JSON.stringify(this.query.filters),
          pq_sort: JSON.stringify(this.query.sort),
          pq_curPage: Math.ceil(+this.query.offset / +this.query.limit) + 1,
          pq_rPP: this.query.limit,
        },
      })
        .then((response) => {
          console.log(response);
          this.data = response.data.result.data ;
          this.total = response.data.result.total;
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.pending = false
        })
    },
  },
  data() {
    return {
      gridName: 'AlbumGrid',
      columns: [
        {
          title: 'Akce',
          tdComp: 'Actions',
          thStyle: { width: '92px', 'text-align': 'center' },
          tdStyle: { width: '92px' },
          fixed: true,
        },
        {
          title: 'Název',
          field: 'name',
          sortable: true,
          thComp: 'FilterTh',
          colStyle: { width: '80px' },
        },
        {
          title: 'Popisek',
          field: 'description',
          sortable: true,
          thComp: 'FilterTh',
          colStyle: { width: '80px' },
        }
      ],
      pending: true,
      data: [],
      // selection: [],
      supportBackup: true,
      tblStyle: 'table-layout: fixed', // must
      tblClass: 'table-bordered',
      fixHeaderAndSetBodyMaxHeight: 500,
      fullHeight: {
        enabled: true,
        heightCorrection: -370,
      },
      total: 0,
      query: {},
      xprops: {
        editRouteName: 'contentGalleryEdit',
        eventbus: new Vue(),
        allowDelete: this.hasPermission('Gallery_Administration_Editing')
      },
    }
  },
  beforeDestroy() {
    this.xprops.eventbus.$off()
  },
  created() {
    let self = this
    this.xprops.eventbus
      .$on('RELOAD', this.loadData)
      .$on('DELETE_ITEM', (payload) => {
        CMSGalleryApi.delete(payload.id)
        .then(() => {
            self.xprops.eventbus.$emit('RELOAD');
              this.$toasted.success('Položka byla úspěšně odstraněna!', {
              theme: 'toasted-primary',
              position: 'bottom-right',
              duration: 3000
            });

        }).catch(e => {
            console.error(e);
            this.$swal({
                type: "error",
                title: "Nastala chyba",
                text: e.data.result.message
            });
        })
    });
  },
  watch: {
    query: {
      handler() {
        this.loadData()
      },
      deep: true,
    },
  },
}
</script>
